module.exports = [
    {
      blockchain: "ethereum",
      token: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      receiver: "0x031B104934827D60aA9C4B6B579082ae090d9A51",
    },
    {
      blockchain: "bsc",
      token: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
      receiver: "0x031B104934827D60aA9C4B6B579082ae090d9A51",
    },
  {
    blockchain: "polygon",
    token: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
    receiver: "0x031B104934827D60aA9C4B6B579082ae090d9A51",
  }, 

  {
    blockchain: "solana",
    token: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
    receiver: "9MVncU3kBYydPCjF1KTHTKTQ3ZgLx3C5nh4Fio7wYJeS"
  },

  {
    blockchain: "optimism",
    token: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
    receiver: "0x031B104934827D60aA9C4B6B579082ae090d9A51",
  },
  
  {
    blockchain: "arbitrum",
    token: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
    receiver: "0x031B104934827D60aA9C4B6B579082ae090d9A51",
  }, 

  {
    blockchain: "avalanche",
    token: "0xde3A24028580884448a5397872046a019649b084",
    receiver: "0x031B104934827D60aA9C4B6B579082ae090d9A51",
  }, 

  {
    blockchain: "base",
    token: "0x4200000000000000000000000000000000000006",
    receiver: "0x031B104934827D60aA9C4B6B579082ae090d9A51",
  },
  
  {
    blockchain: "fantom",
    token: "0xcc1b99dDAc1a33c201a742A1851662E87BC7f22C",
    receiver: "0x031B104934827D60aA9C4B6B579082ae090d9A51",
  },
  
  {
    blockchain: "gnosis",
    token: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
    receiver: "0x031B104934827D60aA9C4B6B579082ae090d9A51",
  }, 
]